import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import './ProjectProgress.scss'

const ProjectProgress = ({ step, stepCount }) => {
  const progressBarClassNames = classnames('c-project-progress__bar', {
    'c-project-progress__bar--completed': step === stepCount,
  })

  const width = `${(step / (stepCount - 1)) * 100}%`

  return (
    <div className="c-project-progress">
      <div className={progressBarClassNames} style={{ width }} />
    </div>
  )
}

ProjectProgress.propTypes = {
  step: PropTypes.number.isRequired,
  stepCount: PropTypes.number.isRequired,
}

export default ProjectProgress
